import { useInstallPrompt } from "../hooks/useInstallPrompt";

export function InstallBanner() {
  const { canInstall, promptInstall, dismiss } = useInstallPrompt();

  if (!canInstall) return null;

  return (
    <div className="install-banner">
      <p>
        <strong>Installa IncassaFlow</strong> sul tuo dispositivo per un accesso rapido.
      </p>
      <div className="install-banner-actions">
        <button type="button" className="primary-btn primary-btn--sm" onClick={() => void promptInstall()}>
          Installa
        </button>
        <button type="button" className="ghost-btn ghost-btn--sm" onClick={dismiss}>
          Non ora
        </button>
      </div>
    </div>
  );
}
